export default __webpack_public_path__ + "images/0xc518a88c67ceca8b3f24c4562cb71deeb2af86b7.png";